import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as SendIconSvg } from '../../assets/send-icon.svg';

export const SendIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={SendIconSvg} {...props} />;
};
